.body__container .body__content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  width: 100%;
  max-width: var(--max-screen-width);
  min-height: 100vh;

  background-color: white;
}

@media screen and (width <= 640px) {
  .body__container .body__content {
    padding: unset;
  }
}

